import { useNavigate } from 'react-router-dom';
import { Grid, Button } from '@mui/material';
import { useAuthorize } from '../../../hooks/use-authorize';
import { UserPermissionName } from '../../../models/user-permission-name';

interface ActionPage {
  officeID?: number;
  isLoading: boolean;
  handleSubmit?: (data: any) => any;
}

const styling = {
  root: { paddingRight: '15px', paddingBottom: '10px' },
  buttonStyle: { width: '130px' },
};

export const FormButtons = ({ officeID, isLoading, handleSubmit }: ActionPage) => {
  const navigate = useNavigate();
  const onCancel = () => {
    if (!officeID) {
      navigate(`/offices`);
    } else {
      navigate(`/offices/details/${officeID}`);
    }
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Grid container justifyContent="space-between" spacing={1}>
      <Grid item>
        <Button variant="outlined" style={styling.buttonStyle} onClick={onCancel}>
          Cancel
        </Button>
      </Grid>
      <Grid item>
        {!handleSubmit ? (
          <Button
            type={'submit'}
            disabled={isLoading || isReadOnlyPermission}
            variant="contained"
            disableElevation={true}
            style={styling.buttonStyle}
          >
            Save
          </Button>
        ) : (
          <Button
            type={'button'}
            disabled={isLoading || isReadOnlyPermission}
            variant="contained"
            disableElevation={true}
            style={styling.buttonStyle}
            onClick={handleSubmit}
          >
            Save
          </Button>
        )}
      </Grid>
    </Grid>
  );
};
